import { gql, TypedDocumentNode } from "@apollo/client";

export type CareerConsultantSection = {
  id: string;
  name: string;
  legacyId: string | null;
};

export type MeCareerConsultantSectionsResponse = {
  me: { id: string } | null;
  careerConsultantSections: CareerConsultantSection[];
};

export const ME_CAREER_CONSULTANT_SECTIONS_QUERY: TypedDocumentNode<MeCareerConsultantSectionsResponse> = gql`
  query MeCareerConsultantSections {
    me {
      id
    }
    careerConsultantSections {
      id
      name
      legacyId
    }
  }
`;

export type QuickAddPersonProgramStatusNode = {
  pgaId: string;
  latestProgram: { status: string | null } | null;
};

export type QuickAddPersonProgramStatusResponse = {
  people: { nodes: QuickAddPersonProgramStatusNode[] } | null;
};

export type QuickAddPersonProgramStatusVariables = {
  input: { pgaIds: string[] };
  first: number;
};

export const QUICK_ADD_PERSON_PROGRAM_STATUS_QUERY: TypedDocumentNode<
  QuickAddPersonProgramStatusResponse,
  QuickAddPersonProgramStatusVariables
> = gql`
  query QuickAddPersonProgramStatus($input: BackofficeCRMPeopleInput!, $first: Int!) {
    people(first: $first, input: $input) {
      nodes {
        id
        pgaId
        latestProgram {
          id
          status
        }
      }
    }
  }
`;
